export {
  SegmentedControlItem as Item,
  SegmentedControlPropsContext as PropsContext,
  SegmentedControlRoot as Root,
  useSegmentedControlPropsContext as usePropsContext,
} from "./segmented-control"
export type {
  SegmentedControlItemProps as ItemProps,
  SegmentedControlRootProps as RootProps,
} from "./segmented-control"
export {
  SegmentedControlContext as Context,
  SegmentedControlDescendantsContext as DescendantsContext,
  useSegmentedControlContext as useContext,
  useSegmentedControlDescendant as useDescendant,
  useSegmentedControlDescendants as useDescendants,
} from "./use-segmented-control"
